export const HIVE_SLASH_MENU_WIDGET = 'hive-slash-menu-widget';
export const HIVE_SLASH_MENU_TRIGGER_KEY = '/';
export const HIVE_SLASH_MENU_TOOLTIP_TIMEOUT = 800;
export const HIVE_SLASH_MENU_MAX_HEIGHT = 390;
